import React, { useState } from "react";
import { AiOutlineArrowDown, AiOutlineArrowRight } from "react-icons/ai";

const FiniancialPerformanceComponent = () => {
  const [isActive, setIsActive] = useState(true);
  const Report2022 = "http://izb.co.zm/reports/2022.pdf";
  const Report2021 = "http://izb.co.zm/reports/2021.pdf";
  const Report2020 = "http://izb.co.zm/reports/2020.pdf";
  const Report2019 = "http://izb.co.zm/reports/2019.pdf";
  const Report2018 = "http://izb.co.zm/reports/2018.pdf";
  const Report2017 = "http://izb.co.zm/reports/2017.pdf";
  const Report2016 = "http://izb.co.zm/reports/2016.pdf";
  const Report2015 = "http://izb.co.zm/reports/2015.pdf";
  const Report2023 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/2023-annual report.pdf";
  const Report2025 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Indo%20Zambia%20Bank%20Limited%20Annual%20Report%202025.pdf";
  const Report2024 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/OFFICIAL INDO ZAMBIA BANK 2024 ANNUAL REPORT.pdf"

  const arrowwreport = "https://izbassetsmain.blob.core.windows.net/izbwebassets/report2023.png";
  
  const IZBAnnualReport2025 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZBAnnualReport2025-thumbnail.jpg.jpeg";
  const IZBAnnualReport2024 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZBAnnualReport2024-banner.png";

  const img2022 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/2021report.png";
  const img2021 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/2.png";
  const img2020 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/1.png";
  const img2019 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/6.png";
  const img2018 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/5.png";
  const img2017 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/4.png";
  const img2016 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/3.png";
  const img2015 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/7.png";
  const statement1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/9.png";
  const statement2 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/10.png";
  const statement3 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/financial-11.png";
  const statement4 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/financial-12.png";
  const downloadFile = (url) => {
    window.open(url, '_blank');
  };
  return (
    <div className="container">
      <div className="row">
        <div className="col-xl-12">
          <div className="faq-style1__content pt-md-4">
            <ul className="accordion-box">
              <li
                onClick={() => setIsActive(isActive)}
                className="accordion block active-block d-inline align-items-center"
              >
                <div
                  className="acc-btn active"
                  style={{ backgroundColor: "#9E1B1E", backgroundSize: "20px"  }}
                >
                  <div className="icon-outer text-white">
                    {isActive ? (
                      <AiOutlineArrowRight size={20} />
                    ) : (
                      <AiOutlineArrowDown size={20} />
                    )}
                  </div>
                  <h3 className="text-white">IZB Annual Reports </h3>
                </div>
                {isActive && (
                  <div className="acc-content current">
                    <div className="row mt-5">


                    <div className="col-sm-6 col-md-3 col-xl-3 text-center">
                        <div>
                          <img src={IZBAnnualReport2025} alt=""  style={{width:"80%"}}/>
                        </div>
                        <div className="my-3">
                          <p>
                            <strong>Report - 2025</strong>
                          </p>
                          <div
                            className="mt-3"
                            // style={{ backgroundColor: "#9E1B1E" }}
                          >
                            <button className="btn-one shadow my-3 bg-white rounded " type="submit">
                              <span
                                onClick={() => {
                                  downloadFile(Report2025);
                                }}
                                className="txt "
                              >
                                Download PDF <AiOutlineArrowDown size={20} />{" "}
                              </span>
                            </button>
                          </div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-md-3 col-xl-3 text-center">
                        <div>
                          <img src={IZBAnnualReport2024} alt=""  style={{width:"80%"}}/>
                        </div>
                        <div className="my-3">
                          <p>
                            <strong>Report - 2024</strong>
                          </p>
                          <div
                            className="mt-3"
                            // style={{ backgroundColor: "#9E1B1E" }}
                          >
                            <button className="btn-one shadow my-3 bg-white rounded " type="submit">
                              <span
                                onClick={() => {
                                  downloadFile(Report2024);
                                }}
                                className="txt "
                              >
                                Download PDF <AiOutlineArrowDown size={20} />{" "}
                              </span>
                            </button>
                          </div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-md-3 col-xl-3 text-center">
                        <div>
                          <img src={arrowwreport} alt=""  style={{width:"80%"}}/>
                        </div>
                        <div className="my-3">
                          <p>
                            <strong>Report - 2023</strong>
                          </p>
                          <div
                            className="mt-3"
                            // style={{ backgroundColor: "#9E1B1E" }}
                          >
                            <button className="btn-one shadow my-3 bg-white rounded " type="submit">
                              <span
                                onClick={() => {
                                  downloadFile(Report2023);
                                }}
                                className="txt "
                              >
                                Download PDF <AiOutlineArrowDown size={20} />{" "}
                              </span>
                            </button>
                          </div>
                        </div>
                    </div>









                    <div className="col-sm-6 col-md-3 col-xl-3 text-center">
                        <div>
                          <img src={img2022} alt="" style={{width:"80%"}}/>
                        </div>
                        <div className="my-3">
                          <p>
                            <strong>Report - 2022</strong>
                          </p>
                          <div
                            className="mt-3"
                            // style={{ backgroundColor: "#9E1B1E" }}
                          >
                            <button className="btn-one shadow my-3 bg-white rounded " type="submit">
                              <span
                                onClick={() => {
                                  downloadFile(Report2022);
                                }}
                                className="txt "
                              >
                                Download PDF <AiOutlineArrowDown size={20} />{" "}
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-3 col-xl-3 text-center">
                        <div>
                          <img src={img2021} alt=""  style={{width:"80%"}}/>
                        </div>
                        <div className="my-3">
                          <p>
                            <strong>Report - 2021</strong>
                          </p>
                          <div
                            className="mt-3"
                            // style={{ backgroundColor: "#9E1B1E" }}
                          >
                            <button className="btn-one shadow my-3 bg-white rounded " type="submit">
                              <span
                                onClick={() => {
                                  downloadFile(Report2021);
                                }}
                                className="txt "
                              >
                                Download PDF <AiOutlineArrowDown size={20} />{" "}
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-3 col-xl-3 text-center">
                        <div>
                          <img src={img2020} alt=""  style={{width:"80%"}}/>
                        </div>
                        <div className="my-3">
                          <p>
                            <strong>Report - 2020</strong>
                          </p>
                          <div
                            className="mt-3"
                            // style={{ backgroundColor: "#9E1B1E" }}
                          >
                            <button className="btn-one shadow my-3 bg-white rounded " type="submit">
                              <span
                                onClick={() => {
                                  downloadFile(Report2020);
                                }}
                                className="txt"
                              >
                                Download PDF <AiOutlineArrowDown size={20} />{" "}
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-3 col-xl-3 text-center">
                        <div>
                          <img src={img2019} alt=""  style={{width:"80%"}}/>
                        </div>
                        <div className="my-3">
                          <p>
                            <strong>Report - 2019</strong>
                          </p>
                          <div
                            className="mt-3"
                            // style={{ backgroundColor: "#9E1B1E" }}
                          >
                            <button className="btn-one shadow my-3 bg-white rounded " type="submit">
                              <span
                                onClick={() => {
                                  downloadFile(Report2019);
                                }}
                                className="txt "
                              >
                                Download PDF <AiOutlineArrowDown size={20} />{" "}
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-3 col-xl-3 text-center">
                        <div>
                          <img src={img2018} alt=""  style={{width:"80%"}}/>
                        </div>
                        <div className="my-3">
                          <p>
                            <strong>Report - 2018</strong>
                          </p>
                          <div
                            className="mt-3"
                            // style={{ backgroundColor: "#9E1B1E" }}
                          >
                            <button className="btn-one shadow my-3 bg-white rounded " type="submit">
                              <span
                                onClick={() => {
                                  downloadFile(Report2018);
                                }}
                                className="txt"
                              >
                                Download PDF <AiOutlineArrowDown size={20} />{" "}
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-3 col-xl-3 text-center">
                        <div>
                          <img src={img2017} alt=""  style={{width:"80%"}}/>
                        </div>
                        <div className="my-3">
                          <p>
                            <strong>Report - 2017</strong>
                          </p>
                          <div
                            className="mt-3"
                            // style={{ backgroundColor: "#9E1B1E" }}
                          >
                            <button className="btn-one shadow my-3 bg-white rounded " type="submit">
                              <span
                                onClick={() => {
                                  downloadFile(Report2017);
                                }}
                                className="txt"
                              >
                                Download PDF <AiOutlineArrowDown size={20} />{" "}
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-3 col-xl-3 text-center">
                        <div>
                          <img src={img2016} alt=""  style={{width:"80%"}}/>
                        </div>
                        <div className="my-3">
                          <p>
                            <strong>Report - 2016</strong>
                          </p>
                          <div
                            className="mt-3"
                            // style={{ backgroundColor: "#9E1B1E" }}
                          >
                            <button className="btn-one shadow my-3 bg-white rounded " type="submit">
                              <span
                                onClick={() => {
                                  downloadFile(Report2016);
                                }}
                                className="txt"
                              >
                                Download PDF <AiOutlineArrowDown size={20} />{" "}
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-3 col-xl-3 text-center">
                        <div>
                          <img src={img2015} alt=""  style={{width:"80%"}}/>
                        </div>
                        <div className="my-3">
                          <p>
                            <strong>Report - 2015</strong>
                          </p>
                          <div
                            className="mt-3"
                            // style={{ backgroundColor: "#9E1B1E" }}
                          >
                            <button className="btn-one shadow my-3 bg-white rounded " type="submit">
                              <span
                                onClick={() => {
                                  downloadFile(Report2015);
                                }}
                                className="txt"
                              >
                                Download PDF <AiOutlineArrowDown size={20} />{" "}
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </li>
              <li
                onClick={() => setIsActive(isActive)}
                className="accordion block active-block"
              >
                <div
                  className="acc-btn active"
                  style={{ backgroundColor: "#9E1B1E", backgroundSize: "20px" }}
                >
                  <div className="icon-outer text-white">
                    {isActive ? (
                      <AiOutlineArrowRight size={20} />
                    ) : (
                      <AiOutlineArrowDown size={20} />
                    )}
                  </div>
                  <h3 className="text-white">IZB Financial Statement</h3>
                </div>
                {isActive && (
                  <div className="acc-content current">
                    <div className="row mt-5">
                      <div className="col-sm-6 col-md-6 col-xl-6 text-center">
                        <div>
                          <img src={statement1} alt="" />
                        </div>
                        <div className="my-3">
                          <p>
                            Quarterly Financial Statements - 30th September,
                            2022
                          </p>

                          <button
                            className="btn-one shadow my-3 bg-white rounded "
                            type="submit"
                            style={{ backgroundColor: "#9E1B1E" }}
                          >
                            <span
                              onClick={() => {
                                downloadFile(Report2021);
                              }}
                              className="txt"
                            >
                              Download PDF <AiOutlineArrowDown size={20} />{" "}
                            </span>
                          </button>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-xl-6 text-center">
                        <div>
                          <img src={statement2} alt="" />
                        </div>
                        <div className="my-3">
                          <p>
                            Quarterly Financial Statements - 31st March, 2022
                          </p>

                          <button
                            className="btn-one shadow my-3 bg-white rounded "
                            type="submit"
                            style={{ backgroundColor: "#9E1B1E" }}
                          >
                            <span
                              onClick={() => {
                                downloadFile(Report2021);
                              }}
                              className="txt"
                            >
                              Download PDF <AiOutlineArrowDown size={20} />{" "}
                            </span>
                          </button>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-xl-6 text-center">
                        <div>
                          <img src={statement3} alt="" />
                        </div>
                        <div className="my-3">
                          <p>
                            Quarterly Financial Statements as at 31st December
                            2021
                          </p>

                          <button
                            className="btn-one shadow my-3 bg-white rounded "
                            type="submit"
                            style={{ backgroundColor: "#9E1B1E" }}
                          >
                            <span
                              onClick={() => {
                                downloadFile(Report2021);
                              }}
                              className="txt "
                            >
                              Download PDF <AiOutlineArrowDown size={20} />{" "}
                            </span>
                          </button>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-xl-6 text-center">
                        <div>
                          <img src={statement4} alt="" />
                        </div>
                        <div className="my-3">
                          <p>Quarterly Financial Statements - 30-06-2021</p>

                          <button
                            className="btn-one shadow my-3 bg-white rounded "
                            type="submit"
                            style={{ backgroundColor: "#9E1B1E" }}
                          >
                            <span
                              onClick={() => {
                                downloadFile(Report2021);
                              }}
                              className="txt"
                            >
                              Download PDF <AiOutlineArrowDown size={20} />{" "}
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FiniancialPerformanceComponent;
